/**
 *
 * 控制台日志初始化
 * 本模块是第三方模块 loglevel（https://www.npmjs.com/package/loglevel） 的功能扩展，主要增加内容：
 * (1) 统一增加控制台打印日志前缀
 * (2) 日志单个变量扩展到全变量
 * (3) 增加日志打印控制，可以通过浏览器URL传参数loglevel或者通过sessionStorage设置loglevel来控制日志打印。
 *
 * 支持5种方法：log.trace(msg)、log.debug(msg)、log.info(msg)、log.warn(msg)、log.error(msg)
 * level=5 什么都不输出
 * level=4 输出error
 * level=3 输出error、warn - 默认级别
 * level=2 输出error、warn、info
 * level=1 输出error、warn、info、debug（log.debug 等价 log.log）
 * level=0 输出error、warn、info、debug、trace（即打印全部）
 * 实际日志打印，使用的仍然是使用 loglevel 模块
 */
import log from 'loglevel';

// 修改默认日志级别
log.setDefaultLevel(5);

// 统一增加前缀
const originalFactory = log.methodFactory;
log.methodFactory = function (methodName, logLevel, loggerName) {
  const rawMethod = originalFactory(methodName, logLevel, loggerName);

  return function () {
    const messages = ['[vhall-ai]'];
    for (var i = 0; i < arguments.length; i++) {
      messages.push(arguments[i]);
    }
    rawMethod.apply(undefined, messages);
  };
};

// Be sure to call setLevel method in order to apply plugin
log.setLevel(log.getLevel());

// 获取query参数并解析 loglevel 参数
const query = window.location.search || window.location.hash;
const parser = /([^=?#&]+)=?([^&]*)/g;
let part, ll;
while ((part = parser.exec(query))) {
  if (part[1] === 'loglevel') {
    ll = parseInt(part[2]);
    break;
  }
}
//  query参数没有从 sessionStorage获取 loglevel 参数
if (typeof ll === undefined) ll = window.sessionStorage.getItem('loglevel');

if (ll >= 0 && ll <= 5) {
  log.setLevel(ll);
} else {
  log.resetLevel();
}
